// extracted by mini-css-extract-plugin
module.exports = {"button":"_3Z1V_wW6jBhVynGfafqNy0","buttons":"_20KgDC58TC-MFGGLi_29F6","nextButton":"_32V4BKENTjuKss94zY4T6f"};